import { gql } from "@apollo/client";

export const GET_PROFESIONALES = gql`
  query GetProfesionalesAsistencial($idDelegacion: Int!, $idTipoProfesional: Int!) {
    profesionalesAsistencial(
      idDelegacion: $idDelegacion
      idTipoProfesional: $idTipoProfesional
    ) {
      idProfesional
      tituloHabilitante
      nombre
      apellido
      idCalificacion
      idClaseMonitoreo
    }
  }
`;